import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { TariffsEntityGrid } from '../features/tariffs-entity-grid/tariffs-entity-grid';

export const AllTariffsPage = observer(() => {
  return (
    <AppPage perm="PERM_TARIFF_READ" noWrapper>
      <TariffsEntityGrid />
    </AppPage>
  );
});
